import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons } from '@/utils'

import button from '@/components/button'
import form from '@/components/services/templates/form'

function renderCreateTemplateDialogBody(h) {
  return h(
    'div',
    {
      class: `${Services.templates}-dialog__body`
    },
    [
      h(
        form,
        {
          props: {
            value: this.payload
          },
          on: {
            input: event => {
              this.payload = event
            }
          }
        }
      )
    ]
  )
}
function renderCreateTemplateDialogFooter(h) {
  return h(
    'div',
    {
      class: 'dialog__footer',
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.showDialog = false
            }
          }
        }
      ),
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.create'),
            color: Colors.primary,
            loading: this.loading,
            disabled: this.loading || !this.validation
          },
          on: {
            click: () => {
              this.create()
            }
          }
        }
      )
    ]
  )
}
function renderDialog(h) {
  return h(
    components.dialog,
    {
      props: {
        title: this.getTranslate(`${Services.templates}.dialogs.create`),
        value: this.showDialog,
        maxWidth: 600
      },
      on: {
        input: event => {
          this.showDialog = event
        }
      }
    },
    [
      renderCreateTemplateDialogBody.call(this, h),
      renderCreateTemplateDialogFooter.call(this, h)
    ]
  )
}
export default function(h) {
  let saveButtonLabel
  if (this.viewport.size.width > 600) {
    saveButtonLabel = this.getTranslate('misc.buttons.save')
  }

  return h(
    button,
    {
      props: {
        label: saveButtonLabel,
        icon: icons.save,
        mode: buttonModes.flat,
        color: Colors.success,
        disabled: this.disabled,
        tooltip: this.getTranslate(`${Services.sendings}.tooltips.save`)
      },
      scopedSlots: {
        dialog: () => {
          return renderDialog.call(this, h)
        }
      },
      on: {
        click: () => {
          this.showDialog = true
        }
      }
    }
  )
}
